export default "__VITE_ASSET__CGJQvyOt__"